import React, { Component } from "react";
import { Grid, Box, CardContent, CardMedia, Tab, Tabs } from "@mui/material";
import CtBtn from "./CustomTool/CtBtn";
import CtDtp from "./CustomTool/CtDtp";
import { connect } from "react-redux";
import {
  mapStatetoProps,
  mapSetActiveMenuToProps,
  mapSetActiveMenu_MenuVisibility_ToProps,
} from "../mapRedux/mapReduxProps";
import { withRouter } from "../HOC/withRouter";
import HOCVerifyIsUser from "../HOC/HOCVerifyIsUser";
import HoCtToastContainer from "../HOC/HoCtToastContainer";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { type } from "@testing-library/user-event/dist/type";
import Checkbox from "@mui/material/Checkbox";
import CtCmbEditable from "./CustomTool/CtCmbEditable";
import {
  get_YMD_from_SYS,
  isValidItem,
  applyTrimOnObjectValues,
  getRoundOff,
  getString_or_Blank4Null,
  validatedate_min_max,
  get_30DaysBack_FromCurrentDate,
  getlocalstoragedate,
  setlocalstoragedate,
} from "../SystemUtility/SystemUtility";
import FormControlLabel from "@mui/material/FormControlLabel";
import { apiURL, fetchCustomerMaster, fetchSales } from "./API";
import ResetDate from "../images/resetdate.png";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import CtMultiSelect from "../Component/CustomTool/CtMultiSelect";
import CtTxtNum from "./CustomTool/CtTxtNum";
import CtCmb from "./CustomTool/CtCmb";
import AlertResponsiveDialog from "./CustomTool/AlertResponsiveDialog";
import SalesInvoiceSelection from "./SalesInvoiceSelection";

class SalesReport extends Component {
  state = {
    formData: {
      dtpFromDate: "",
      dtpToDate: "",
      dtpInvoiceToDate: "",
      dtpInvoiceFromDate: "",
      cmbType: "Date Wise Summary",
      cmbInvoiceType: "",
      cmbCustomer: "",
      cmbInvoiceCustomer: "",
      chekNewpage: false,
      checkPrint: false,
      cmbSelection: "Bill No Range",
      txtFromBillNo: "",
      txtToBillNo: "",
      value: "1",
      showDateRang: true,
    },
    types: [
      { type: "Date Wise Summary" },
      { type: "Date Wise Detail" },
      { type: "Date Wise Detail With Item" },
      { type: "Customer wise Summary" },
      { type: "Customer wise Detail" },
      { type: "Customer wise Detail With Item" },
    ],
    customers: [],
    invoiceTypes: [],
    billNumbers: [],
    cmbMulBillNo: [],
    Selections: [
      { vac_selection: "Bill No Range" },
      { vac_selection: "Bill No Selection" },
    ],
    ARD: null,
  };

  //#region Component
  componentDidMount() {
    document.title = "RA : Sales Report";
    this.props.setActiveMenu("SaleReport");
    this.props.verifyUserID(
      this.onFormLoad,
      this.props.navInfo.subMenuMaster,
      this.props.setSubMenu_Master_Entry,
      this.props.setUserPrivileges
    );
  }
  //#endregion Component

  //#region Handles
  handleOnChange = (e) => {
    this.setState(
      {
        formData: {
          ...this.state.formData,
          [e.target.name]: e.target.value,
        },
      },
      () => {
        if (e.target.name === "cmbType") {
          if (
            this.state.formData.cmbType === "Date Wise Summary" ||
            this.state.formData.cmbType === "Date Wise Detail"
          ) {
            //#To hide the checkbox and set it's value = ""
            this.setState({
              formData: {
                ...this.state.formData,
                chekNewpage: false,
              },
            });
          }
        } else if (
          e.target.name === "dtpFromDate" ||
          e.target.name === "dtpToDate"
        ) {
          this.setfrom_todate();
        } else if (e.target.name == "cmbInvoiceType") {
          this.GetBillNo();
        } else if (e.target.name == "cmbSelection") {
          if (e.target.value == "Bill No Range") {
            this.setState({
              formData: {
                ...this.state.formData,
                showDateRang: true,
              },
              cmbMulBillNo: [],
            });
          } else if (e.target.value == "Bill No Selection") {
            this.setState({
              formData: {
                ...this.state.formData,
                txtFromBillNo: "",
                txtToBillNo: "",
                showDateRang: false,
              },
            });
          }
        }
      }
    );
  };

  handleOnChangeBillNo = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  handleOnCheckChange = (e) => {
    this.setState({
      formData: {
        ...this.state.formData,
        [e.target.name]: e.target.checked,
      },
    });
  };
  handleOnChangeTab = (event, newValue) => {
    this.setState({
      formData: { ...this.state.formData, value: newValue },
    });
  };
  handleOnCheckChange_print = (e) => {
    this.setState({
      formData: {
        ...this.state.formData,
        [e.target.name]: e.target.checked,
      },
    });
  };
  //#endregion Handles

  //#region Function
  getCmbType4BE(ReportType) {
    if (ReportType === "Date Wise Summary") {
      return "SalesDateWiseSummary";
    } else if (ReportType === "Date Wise Detail") {
      return "SalesDateWiseDetail";
    } else if (ReportType === "Date Wise Detail With Item") {
      return "SalesDateWiseItemDetail";
    } else if (ReportType === "Customer wise Summary") {
      return "SalesCustomerWiseSummary";
    } else if (ReportType === "Customer wise Detail") {
      return "SalesCustomerWiseDetail";
    } else if (ReportType === "Customer wise Detail With Item") {
      return "SalesCustomerWiseItemDetail";
    }
  }

  trimFormData = (nextFunctionCall) => {
    let formData = applyTrimOnObjectValues({
      formData: this.state.formData,
      excludeKeysArray: ["chekNewpage", "checkPrint"],
    });
    this.setState({ formData }, () => {
      if (nextFunctionCall) {
        nextFunctionCall();
      }
    });
  };

  GetBillNo = () => {
    this.props.notifyProcessing();
    const reqData = {
      Op: "LoadDataOnSalesInvoicePrintBillTypeSelection",
      bint_acid: localStorage.getItem("acid"),
      bint_acyear: localStorage.getItem("ACY"),
      vac_billtype: this.state.formData.cmbInvoiceType,
    };
    fetchSales(reqData)
      .then((res) => {
        this.props.closeUpdateProcessing();

        this.setState({
          billNumbers: res.data.InvoiceNoList,
        });
      })
      .catch((err) => {
        console.log("Unknown error occurred in getInfo.", err);
        this.props.updateProcessing(
          "error",
          "Unknown error occurred in loading . " + err
        );
      });
  };

  validateInvoicePdf = () => {
    let result = false;
    if (this.state.formData.cmbInvoiceType.length <= 0) {
      this.props.toastErrorMsg("Select Invoice Type", "cmbInvoiceType");
    } else if (
      !isValidItem(
        this.state.invoiceTypes,
        "vac_invoicetype",
        this.state.formData.cmbInvoiceType
      )
    ) {
      this.props.toastErrorMsg("Select Valid Invoice Type", "cmbInvoiceType");
    } else if (
      this.state.formData.dtpInvoiceFromDate.length <= 0 &&
      this.state.formData.dtpInvoiceToDate.length <= 0 &&
      this.state.formData.cmbInvoiceCustomer.length <= 0 &&
      Number(this.state.formData.txtFromBillNo) <= 0 &&
      Number(this.state.formData.txtToBillNo) <= 0 &&
      this.state.cmbMulBillNo.length <= 0
    ) {
      this.props.toastErrorMsg("Select At least One");
    } else if (
      this.state.formData.dtpInvoiceFromDate.length > 0 &&
      validatedate_min_max(
        this.state.formData.dtpInvoiceFromDate,
        "dtpInvoiceFromDate",
        this.props.toastErrorMsg
      ) == false
    ) {
      return result;
    } else if (
      this.state.formData.dtpInvoiceFromDate.length > 0 &&
      this.state.formData.dtpInvoiceToDate.length <= 0
    ) {
      this.props.toastErrorMsg("Select To Date", "dtpInvoiceToDate");
    } else if (
      this.state.formData.dtpInvoiceToDate.length > 0 &&
      validatedate_min_max(
        this.state.formData.dtpInvoiceToDate,
        "dtpInvoiceToDate",
        this.props.toastErrorMsg
      ) == false
    ) {
      return result;
    } else if (
      this.state.formData.dtpInvoiceFromDate.length <= 0 &&
      this.state.formData.dtpInvoiceToDate.length > 0
    ) {
      this.props.toastErrorMsg("Select From Date", "dtpInvoiceFromDate");
    } else if (
      this.state.formData.cmbSelection == "Bill No Range" &&
      Number(this.state.formData.txtFromBillNo) > 0 &&
      Number(this.state.formData.txtToBillNo) <= 0
    ) {
      this.props.toastErrorMsg("Enter To Bill Number", "txtToBillNo");
    } else if (
      this.state.formData.cmbSelection == "Bill No Range" &&
      Number(this.state.formData.txtFromBillNo) <= 0 &&
      Number(this.state.formData.txtToBillNo) > 0
    ) {
      this.props.toastErrorMsg("Enter From Bill Number", "txtFromBillNo");
    } else {
      result = true;
    }
    return result;
  };

  validateFromToDate = () => {
    let result = false;
    const fromDate = this.state.formData.dtpFromDate;
    const toDate = this.state.formData.dtpToDate;

    if (this.state.formData.cmbType.length <= 0) {
      this.props.toastErrorMsg("Select Type", "cmbType");
    } else if (
      !isValidItem(this.state.types, "type", this.state.formData.cmbType)
    ) {
      this.props.toastErrorMsg("Select Valid Type", "cmbType");
    } else if (this.state.formData.dtpFromDate.length <= 0) {
      this.props.toastErrorMsg("Enter Date", "dtpFromDate");
    } else if (
      validatedate_min_max(
        this.state.formData.dtpFromDate,
        "dtpFromDate",
        this.props.toastErrorMsg
      ) == false
    ) {
      return result;
    } else if (this.state.formData.dtpToDate.length <= 0) {
      this.props.toastErrorMsg("Enter Date", "dtpToDate");
    } else if (
      validatedate_min_max(
        this.state.formData.dtpToDate,
        "dtpToDate",
        this.props.toastErrorMsg
      ) == false
    ) {
      return result;
    } else if (new Date(fromDate) > new Date(toDate)) {
      this.props.toastErrorMsg(
        "To Date must be greater than From Date",
        "dtpFromDate"
      );
    } else if (
      this.state.formData.cmbCustomer.length > 0 &&
      !isValidItem(
        this.state.customers,
        "vac_customer",
        this.state.formData.cmbCustomer
      )
    ) {
      this.props.toastErrorMsg("Select Valid Customer", "cmbCustomer");
    } else {
      result = true;
    }
    return result;
  };

  setfrom_todate = (reset = false) => {
    setlocalstoragedate(
      "SalesReport",
      this.state.formData.dtpFromDate,
      this.state.formData.dtpToDate,
      reset
    );
    if (reset) {
      // window.location.reload();
      this.onFormLoad(reset);
      document.getElementById("dtpFromDate").focus();
    }
  };

  reqDataForReport = (bolChkDataExist) => {
    let checkPrint = 0;
    if (
      this.state.formData.cmbType === "Date Wise Detail With Item" ||
      this.state.formData.cmbType === "Supplier wise Detail With Item"
    ) {
      checkPrint = this.state.formData.checkPrint === true ? 1 : 0;
    }
    return {
      Op: "SalesReport",
      bint_acid: localStorage.getItem("acid"),
      bint_acyear: localStorage.getItem("ACY"),
      ReportType: this.getCmbType4BE(this.state.formData.cmbType),
      dat_fromdate: this.state.formData.dtpFromDate,
      dat_todate: this.state.formData.dtpToDate,
      vac_customer: this.state.formData.cmbCustomer,
      int_CustomerWisePage: this.state.formData.chekNewpage === true ? 1 : 0,
      bolChkDataExist: bolChkDataExist,
      checkPrint: checkPrint,
    };
  };

  openSalesReport = () => {
    if (this.validateFromToDate()) {
      this.props.notifyProcessing();
      let reqData = this.reqDataForReport(true);
      fetchSales(reqData)
        .then((res) => {
          if (res.data.msgType === "info") {
            let reqData = this.reqDataForReport(false);
            // Use URLSearchParams to convert the request data object into a query string
            let params = new URLSearchParams(reqData);

            let popupURL = apiURL + "salesdetail.php?" + params.toString();
            window.open(
              popupURL,
              "SalesReport",
              "width=" +
                window.screen.availWidth +
                ",height=" +
                window.screen.availHeight
            );
            this.props.updateProcessing("success", "PDF Open in popup.");
          } else {
            this.props.updateProcessing(res.data.msgType, res.data.message);
          }
        })
        .catch((error) => {
          console.log("Unknown error occurred in openSalesReport.", error);
          this.props.updateProcessing(
            "error",
            "Unknown error occurred in loading . " + error
          );
        });
      // Create a query string from the request data
    }
  };

  onFormLoad = (reset = false) => {
    const { fromdate, todate } = getlocalstoragedate("SalesReport");
    let dtpFromDate = fromdate,
      dtpToDate = todate;
    this.setState(
      {
        formData: {
          ...this.state.formData,
          dtpFromDate,
          dtpToDate,
        },
      },
      () => {
        if (reset == false) {
          this.loadCustomerList();
          // document.getElementById("cmbType").focus();
        }
      }
    );
  };

  openInvoiceARDSelection = () => {
    if (this.validateInvoicePdf() == true) {
      // let vac_billno = Array(this.state.formData.LblBillNo);
      console.log("this.state.cmbMulBillNo", this.state.cmbMulBillNo);
      console.log(
        "this.state.formData.txtFromBillNo",
        this.state.formData.txtFromBillNo
      );
      console.log(
        "this.state.formData.txtToBillNo",
        this.state.formData.txtToBillNo
      );
      this.setState({ ARD: null }, () => {
        let ARD = (
          <AlertResponsiveDialog
            labelDisagree="Close"
            alertMessage=<SalesInvoiceSelection
              bint_acid={localStorage.getItem("acid")}
              bint_acyear={localStorage.getItem("ACY")}
              array_billno={this.state.cmbMulBillNo}
              dat_fromdate={this.state.formData.dtpInvoiceFromDate}
              dat_todate={this.state.formData.dtpInvoiceToDate}
              bint_frombillno={this.state.formData.txtFromBillNo}
              bint_tobillno={this.state.formData.txtToBillNo}
              vac_customer={this.state.formData.cmbInvoiceCustomer}
            />
            defaultOpenDialog={true}
          />
        );
        this.setState({ ARD });
      });
    }
  };

  loadCustomerList = () => {
    this.props.notifyProcessing();
    // const reqData = {
    //   Op: "CustomerNameList",
    //   bint_acid: localStorage.getItem("acid"),
    // };
    // fetchCustomerMaster(reqData)
    //   .then((res) => {
    //     this.props.updateProcessing(res.data.msgType, res.data.message);
    //     this.setState({ customers: res.data.CustomerList });
    //   })
    //   .catch((err) => {
    //     console.log("Unknown error occurred in getInfo.", err);
    //     this.props.updateProcessing(
    //       "error",
    //       "Unknown error occurred in loading . " + err
    //     );
    //   });

    const reqData = {
      Op: "OnSalesReportLoad",
      bint_acid: localStorage.getItem("acid"),
    };
    fetchSales(reqData)
      .then((res) => {
        this.props.closeUpdateProcessing();
        let Print = false;
        if (
          res.data.GeneralSettingList &&
          res.data.GeneralSettingList.length > 0
        ) {
          res.data.GeneralSettingList.map((row) => {
            if (row.vac_module === "Report") {
              if (row.vac_key === "Sales Report Item Remark Print Option") {
                if (row.vac_value === "Checked") {
                  Print = true;
                }
              }
            }
          });
        }
        // this.setState({ customers: res.data.CustomerList });
        this.setState(
          {
            formData: {
              ...this.state.formData,
              checkPrint: Print,
            },
            invoiceTypes: res.data.InvoiceSettingList,
            customers: res.data.CustomerList,
          },
          () => {}
        );
      })
      .catch((err) => {
        console.log("Unknown error occurred in getInfo.", err);
        this.props.updateProcessing(
          "error",
          "Unknown error occurred in loading . " + err
        );
      });
  };
  //#endregion Function

  render() {
    return (
      <form>
        {/* <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          className="title"
        >
          <label htmlFor="Title" style={{ fontSize: "25px", color: "#6f7689" }}>
            <b>Sales Report</b>
          </label>
        </Grid> */}
        <TabContext value={this.state.formData.value}>
          <Box sx={{ borderBottom: 1, borderColor: "divider", width: "100%" }}>
            <TabList
              onChange={this.handleOnChangeTab}
              aria-label="lab API tabs example"
              variant="scrollable"
              scrollButtons="auto"
            >
              <Tab label="Sales Report" value="1" />
              <Tab label="Sales Invoice Print" value="2" />
            </TabList>
          </Box>
          <TabPanel value="1">
            <Grid
              container
              justifyContent="center"
              alignItems="center"
              direction="column"
            >
              <Grid item>
                <Grid
                  container
                  direction="row"
                  justifyContent="flex-start"
                  alignItems="flex-start"
                  spacing={3}
                  marginTop={0}
                >
                  <Grid item>
                    <CtCmbEditable
                      id="cmbType"
                      label="Type*"
                      items={this.state.types}
                      colID="type"
                      value={this.state.formData.cmbType}
                      handleOnChange={this.handleOnChange}
                      width={300}
                      maxLength={50}
                      onKeyDown={this.props.onKeyDown}
                      nextCtrlID="dtpFromDate"
                    />
                  </Grid>
                  <Grid item style={{ display: "inline-flex" }}>
                    <CardContent style={{ paddingBottom: "0px" }}>
                      <CardMedia
                        component="img"
                        alt="Reset Date to Default"
                        sx={{ width: 35 }}
                        image={ResetDate}
                        onClick={() => {
                          this.setfrom_todate(true);
                        }}
                      />
                    </CardContent>
                    <CtDtp
                      id="dtpFromDate"
                      label="From Date*"
                      width="150"
                      handleOnChange={this.handleOnChange}
                      defaultValue={this.state.formData.dtpFromDate}
                      value={this.state.formData.dtpFromDate}
                      onKeyDown={this.props.onKeyDown}
                      accountYear={localStorage.getItem("ACY")}
                    />
                  </Grid>
                  <Grid item>
                    <CtDtp
                      id="dtpToDate"
                      label="To Date*"
                      width="150"
                      handleOnChange={this.handleOnChange}
                      defaultValue={this.state.formData.dtpToDate}
                      value={this.state.formData.dtpToDate}
                      onKeyDown={this.props.onKeyDown}
                      nextCtrlID="cmbCustomer"
                      accountYear={localStorage.getItem("ACY")}

                      // disabled={this.state.disabledProfileData.DOBDS}
                    />
                  </Grid>
                </Grid>
                <Grid
                  container
                  direction="row"
                  justifyContent="flex-start"
                  alignItems="flex-start"
                  spacing={3}
                  marginTop={0}
                >
                  <Grid item>
                    <CtCmbEditable
                      id="cmbCustomer"
                      label="Customer"
                      items={this.state.customers}
                      colID="vac_customer"
                      width={300}
                      // value={this.state.formData.cmbType}
                      handleOnChange={this.handleOnChange}
                      maxLength={50}
                      onKeyDown={this.props.onKeyDown}
                      // nextCtrlID={
                      //   this.state.formData.chekNewpage ? "chekNewpage" : ""
                      // }
                      defaultAction={() => {
                        this.trimFormData(() => {
                          this.openSalesReport();
                        });
                      }}
                    />
                  </Grid>
                  <Grid item>
                    <Grid
                      container
                      direction={"column"}
                      justifyContent={"flex-start"}
                      alignItems={"flex-start"}
                    >
                      <Grid item>
                        {/* {this.state.formData.cmbType !== 'Date Wise Summary' && this.state.formData.cmbType !== 'Date Wise Detail' && ( */}
                        <FormControlLabel
                          control={
                            <Checkbox
                              id="chekNewpage"
                              name="chekNewpage"
                              value={this.state.formData.chekNewpage}
                              checked={this.state.formData.chekNewpage}
                              //  handleOnChange={this.handleOnCheckChange}/>
                              onChange={this.handleOnCheckChange}
                              disabled={
                                this.state.formData.cmbType ===
                                  "Date Wise Summary" ||
                                this.state.formData.cmbType ===
                                  "Date Wise Detail" ||
                                this.state.formData.cmbType ===
                                  "Date Wise Detail With Item"
                              }
                            />
                          }
                          label="Customer Wise New Page"
                        />
                        {/* )} */}
                      </Grid>

                      <Grid item>
                        <FormControlLabel
                          control={
                            <Checkbox
                              id="checkPrint"
                              name="checkPrint"
                              value={this.state.formData.checkPrint}
                              checked={this.state.formData.checkPrint}
                              onChange={this.handleOnCheckChange_print}
                              disabled={
                                this.state.formData.cmbType ===
                                  "Date Wise Summary" ||
                                this.state.formData.cmbType ===
                                  "Date Wise Detail" ||
                                this.state.formData.cmbType ===
                                  "Customer wise Summary" ||
                                this.state.formData.cmbType ===
                                  "Customer wise Detail"
                              }
                            />
                          }
                          label="Print Item Remark"
                        />
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid item>
                    <CtBtn
                      label="PDF"
                      onClick={() => {
                        this.trimFormData(() => {
                          this.openSalesReport();
                        });
                      }}
                    />
                  </Grid>
                </Grid>

                <Grid
                  container
                  direction="row"
                  justifyContent="flex-start"
                  alignItems="flex-start"
                  // marginLeft={11.2}
                ></Grid>
              </Grid>
            </Grid>
          </TabPanel>
          <TabPanel value="2">
            <Grid
              container
              justifyContent="center"
              alignItems="center"
              direction="column"
            >
              <Grid item>
                <Grid
                  container
                  direction="row"
                  justifyContent="flex-start"
                  alignItems="flex-start"
                  spacing={3}
                  marginTop={0}
                >
                  <Grid item>
                    <CtCmb
                      id="cmbInvoiceType"
                      label="Invoice Type*"
                      items={this.state.invoiceTypes}
                      colID="vac_invoicetype"
                      value={this.state.formData.cmbInvoiceType}
                      handleOnChange={this.handleOnChange}
                      width={180}
                      maxLength={50}
                      onKeyDown={this.props.onKeyDown}
                      nextCtrlID="dtpInvoiceFromDate"
                    />
                  </Grid>
                  <Grid item>
                    <CtDtp
                      id="dtpInvoiceFromDate"
                      label="From Date"
                      width="140"
                      handleOnChange={this.handleOnChange}
                      defaultValue={this.state.formData.dtpInvoiceFromDate}
                      value={this.state.formData.dtpInvoiceFromDate}
                      onKeyDown={this.props.onKeyDown}
                      accountYear={localStorage.getItem("ACY")}
                      nextCtrlID="dtpInvoiceToDate"
                    />
                  </Grid>
                  <Grid item>
                    <CtDtp
                      id="dtpInvoiceToDate"
                      label="To Date"
                      width="140"
                      handleOnChange={this.handleOnChange}
                      defaultValue={this.state.formData.dtpInvoiceToDate}
                      value={this.state.formData.dtpInvoiceToDate}
                      onKeyDown={this.props.onKeyDown}
                      nextCtrlID="cmbInvoiceCustomer"
                      accountYear={localStorage.getItem("ACY")}
                    />
                  </Grid>
                </Grid>

                <Grid
                  container
                  direction="row"
                  justifyContent="flex-start"
                  alignItems="center"
                  spacing={3}
                  marginTop={0}
                >
                  <Grid item>
                    <CtCmbEditable
                      id="cmbInvoiceCustomer"
                      label="Customer"
                      items={this.state.customers}
                      colID="vac_customer"
                      width={510}
                      value={this.state.formData.cmbInvoiceCustomer}
                      handleOnChange={this.handleOnChange}
                      maxLength={50}
                      onKeyDown={this.props.onKeyDown}
                      nextCtrlID={"cmbSelection"}
                    />
                  </Grid>
                </Grid>

                <Grid
                  container
                  direction="row"
                  justifyContent="flex-start"
                  alignItems="center"
                  spacing={3}
                  marginTop={0}
                >
                  <Grid item>
                    <CtCmb
                      id="cmbSelection"
                      label="Invoice Type*"
                      items={this.state.Selections}
                      colID="vac_selection"
                      value={this.state.formData.cmbSelection}
                      handleOnChange={this.handleOnChange}
                      width={180}
                      maxLength={50}
                      onKeyDown={this.props.onKeyDown}
                    />
                  </Grid>
                  {this.state.formData.showDateRang == true && (
                    <>
                      <Grid item>
                        <CtTxtNum
                          id="txtFromBillNo"
                          label="From Bill No."
                          handleOnChange={this.handleOnChange}
                          value={this.state.formData.txtFromBillNo}
                          width={100}
                          maxLength={10}
                          textAlign="left"
                          onKeyDown={this.props.onKeyDown}
                          nextCtrlID="txtToBillNo"
                        />
                      </Grid>
                      <Grid item>
                        <CtTxtNum
                          id="txtToBillNo"
                          label="To Bill No."
                          handleOnChange={this.handleOnChange}
                          value={this.state.formData.txtToBillNo}
                          width={100}
                          maxLength={10}
                          textAlign="left"
                          onKeyDown={this.props.onKeyDown}
                        />
                      </Grid>
                    </>
                  )}

                  {this.state.formData.showDateRang == false && (
                    <Grid item>
                      <CtMultiSelect
                        id="cmbMulBillNo"
                        label="Multiple Bill No."
                        items={this.state.billNumbers}
                        handleOnChange={this.handleOnChangeBillNo}
                        selectedItems={this.state.cmbMulBillNo}
                        width="250"
                        maxLength="1000"
                        colID="vac_billno"
                      />
                    </Grid>
                  )}
                </Grid>

                <Grid
                  container
                  direction="row"
                  justifyContent="flex-start"
                  alignItems="center"
                  spacing={3}
                  marginTop={0}
                >
                  <Grid item>
                    <CtBtn
                      label="PDF"
                      onClick={() => {
                        this.openInvoiceARDSelection();
                      }}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </TabPanel>
        </TabContext>
        <Grid item>
          <Box display={{ xs: "none" }} style={{ textAlign: "right" }}>
            {this.state.ARD}
          </Box>
        </Grid>
      </form>
    );
  }
}

export default connect(
  mapStatetoProps,
  mapSetActiveMenu_MenuVisibility_ToProps
)(HOCVerifyIsUser(HoCtToastContainer(withRouter(SalesReport))));
